export default function trackUrlConversion(appType) {
  // let data = {
  //   event: 'appDownload',
  //   appType: appType
  // }
  // if (process.env.NODE_ENV === 'production') {
  //   window.dataLayer.push(data)
  // }
}
